import axios from "axios";
import { BASE_URL } from "./endPoints";

const apiClient = axios.create({
  baseURL: BASE_URL,
  // timeout: 10000,
  // headers: {
  //   "Content-Type": "application/json",
  //   Accept: "application/json",
  // },
  // withCredentials: true,
});
// apiClient.defaults.headers.common = {};
// apiClient.defaults.withCredentials = false;
// apiClient.defaults.headers.post['Content-Type'] = 'application/json';
// apiClient.defaults.headers.common['Accept'] = 'application/json';

// apiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.error("API Error:", error.response || error.message);
//     return Promise.reject(error);
//   },
// );

export default apiClient;
